<nb-select
  [placeholder]="placeholder"
  [formControl]="control"
  [disabled]="disabled"
  fullWidth
  (selectedChange)="onSelectedChange($event)"
  [status]="(control.invalid && control.touched) ? 'danger' : 'basic'">
  <!-- <nb-option *ngIf="default">{{ default }}</nb-option> -->
  <nb-option [value]="undefined">Select...</nb-option>
  <nb-option *ngFor="let item of list" [value]="item[value]" [hidden]="item[hiddenItem]">
    {{ item[display] }}
  </nb-option>
</nb-select>
<span [ngxAppValidationMessageFor]="control" class="error-message">
</span>
